import Handlebars from 'handlebars';
import EventHub from '~/eventHub';
import toastr from 'toastr';
import graphs_template from '~/templates/tra-graphs.handlebars';
import GeneralView from '~/generalView';
import chartService from '~/services/chartService';

var traGraphsView = GeneralView.View.extend({  
	tagName: "div",
	className: '',
	arrusersinfo: [],
	namesbasicobject: {x: {type: 'category', categories: []},y: {tick: {format: d3.format('d')}}},
	events: {
		'click #creategraphexcel' : 'downgraphexcell',
	},
	
	render: function () { 
		this.attachEvents();
		return this;
	},
	
	downgraphexcell: function(){
		var date1 = new Date();
		var options = { year: 'numeric', month: 'numeric', day: 'numeric' };var options2 = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
		date1 = date1.toLocaleDateString(lang+'-GB',options);
		var uri = 'data:application/vnd.ms-excel;base64,'
		, template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
		, base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
		, format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
		var table = "graphtable"; 
		if (!table.nodeType) table = document.getElementById("graphtable")
		var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML }
		var link = document.createElement("a");
		link.download = "Informe de Usuarios "+date1 +".xls";
		link.href = uri + base64(format(template, ctx));
		link.click();
	},
	
	attachEvents: function() {
		var handlebarsTemplate = Handlebars.template(graphs_template);
		this.$el.html(handlebarsTemplate()); 
		this.translate(); 
		var that = this;
		that.createnewsgraph();     
	},
	
	createnewsgraph: function(){
		var that = this;
		Parse.Cloud.run("getAllTrazbyUser").then((usersinfo) => {
			Parse.Cloud.run("getassigednum",{"users": usersinfo.users}).then((usersinfo2) => {
				var names = that.namesbasicobject;
				names.x.categories = [];
				var arrayopenReports = [];
				var arrayassingReports = [];
				var arrayclosedReports = [];
				var arraynumComments = [];
				var arraynumNews = [];
				var arraynumdiscardReports = [];
				var arraynumassignedreportsbyuser = [];
				var openReports = ["Reportes Reabiertos"], assingReports = ["Reportes Asignados por"], closedReports = ["Reportes Cerrados"], numComments = ["Cantidad de Comentarios"], numNews = ["Cantidad de Noticias"], numassignedreportsbyuser = ["Reportes Asignados a usuario"], discarreportsbyuser = ["Reportes Descartados"];
				for (var i = 0; i < usersinfo.usersinfo.length; i++) {
					names.x.categories.push(usersinfo.usersinfo[i][0]);
					openReports.push(usersinfo.usersinfo[i][1]);
					assingReports.push(usersinfo.usersinfo[i][2]);
					closedReports.push(usersinfo.usersinfo[i][3]);
					discarreportsbyuser.push(usersinfo.usersinfo[i][4])
					numComments.push(usersinfo.usersinfo[i][5]);
					numNews.push(usersinfo.usersinfo[i][6]);
					numassignedreportsbyuser.push(usersinfo2[i]);
				}
				arrayopenReports.push(openReports);
				arrayassingReports.push(assingReports);
				arrayclosedReports.push(closedReports);
				arraynumComments.push(numComments);
				arraynumNews.push(numNews);
				arraynumassignedreportsbyuser.push(numassignedreportsbyuser);
				arraynumdiscardReports.push(discarreportsbyuser);
				that.rendergraph(names,arraynumdiscardReports,"#tragraphsdiscardreports",'#FF0000');
				that.rendergraph(names,arrayopenReports,"#tragraphopenreports",'#1f77b4');
				that.rendergraph(names,arrayassingReports,"#tragraphassignedreports",'#aec7e8');
				that.rendergraph(names,arrayclosedReports,"#tragraphsclosedreports",'#ff7f0e');
				that.rendergraph(names,arraynumComments,"#tragraphnumcomments",'#A52A2A');
				that.rendergraph(names,arraynumNews,"#tragraphnumnews",'#2ca02c');
				that.rendergraph(names,arraynumassignedreportsbyuser,"#tragraphnumassignedreports",'#9370DB');
				$(".graphcontainer").css("border","solid 1px #D3D3D3"); 
				$(".graphloader").hide();
				$("#creategraphexcel").show();
				for (var j = 0; j < usersinfo.usersinfo.length; j++) {
					$('.graphtable').append('<tr><td>'+usersinfo.usersinfo[j][0]+'</td><td>'+usersinfo2[j]+'</td><td>'+usersinfo.usersinfo[j][1]+'</td><td>'+usersinfo.usersinfo[j][4]+'</td><td>'+usersinfo.usersinfo[j][3]+'</td><td>'+usersinfo.usersinfo[j][2]+'</td><td>'+usersinfo.usersinfo[j][5]+'</td><td>'+usersinfo.usersinfo[j][6]+'</td></tr>');
				}
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	rendergraph: function(names,dataarray,div,varcolor){
		c3.generate(chartService.getChartConfigforBarCharts(names,dataarray,div,varcolor)); 
	},
});
export default traGraphsView;